<template>
  <div id="wrapper" :class="{'has-notice': hasNotice}">
    <div class="main">
      <top-notice v-if="isActiveNotice"
                  :notice="notice"
                  @close="isActiveNotice = false"
      >
      </top-notice>
      <gnb class="hidden-sm hidden-xs" @showLogoutModal="showLogoutModal"></gnb>
      <div class="hidden-lg hidden-md">
        <mobile-gnb ref="mobileGnb"
                    @setOverlay="(bool)=> { this.activeMobileGnb = bool }"
                    @showLogoutModal="showLogoutModal"
        >
        </mobile-gnb>
        <div v-if="activeMobileGnb" class="sidebar-overlay" @click="$refs.mobileGnb.close()"></div>
      </div>
      <router-view class="content"></router-view>
      <biz-footer v-show="useFooter"></biz-footer>
    </div>
    <div class="overlay"></div>
    <toast-bar></toast-bar>
    <modal v-if="!user.id" ref="loginModal" :id="loginModal.id" :type="loginModal.type" :title="loginModal.title" :size="loginModal.size" :fields="loginModal.fields" @submit="$router.push({name: 'login'})"></modal>
    <modal v-if="user.id" ref="logoutModal" :id="logoutModal.id" :type="logoutModal.type" :title="logoutModal.title" :size="logoutModal.size" :fields="logoutModal.fields" @submit="$store.dispatch('logout')"></modal>
    <modal v-if="user.id" ref="chargeModal" :id="chargeModal.id" :type="chargeModal.type" :title="chargeModal.title" :size="chargeModal.size" :fields="chargeModal.fields" @submit="$router.push({name: 'pricing'})"></modal>
  </div>
</template>

<script>
  import Modal from 'common/components/Modal'
  import ToastBar from 'common/components/ToastMessage'
  import Gnb from '@/components/Gnb'
  import mobileGnb from '@/components/MobileGnb'
  import BizFooter from '@/components/BizFooter'
  import TopNotice from '@/components/TopNotice'
  import eventHub from '@/shared/EventHub'
  import axios from 'axios'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'main-layout',
    components: {
      Gnb,
      mobileGnb,
      BizFooter,
      Modal,
      ToastBar,
      TopNotice
    },
    data () {
      return {
        activeMobileGnb: false,
        isActiveNotice: false,
        notice: {},
        loginModal: {
          id: 'loginModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['로그인이 필요한 서비스입니다.', '로그인화면으로 이동하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        logoutModal: {
          id: 'logoutModal',
          type: 'confirm',
          title: '로그아웃',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['로그아웃 하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        chargeModal: {
          id: 'chargeModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [
                '이용권이 필요한 서비스입니다.',
                '이용권 안내 페이지로 이동하시겠습니까?'
              ],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      }),
      useFooter () {
        // 현재 URL에 페이지에 푸터 사용여부에 따라 푸터 컴포넌트 활성화한다.
        const route = this.$route
        const meta = route.meta
        const useFlag = meta.hasOwnProperty('useFooter') ? meta.useFooter : false

        return useFlag
      },
      hasNotice () {
        // 공지사항 활성화 플래그 True && 인덱스 페이지일 경우 공지사항 출력
        return this.isActiveNotice && this.$route.name === 'index'
      }
    },
    watch: {
      '$route': {
        handler () {
          // 사용자가 로그인 되어있는 경우 라우터에 변경이 있을 때 마다 사용자 유료 정보를 업데이트한다.
          if (this.user.isLogin) {
            this.getPricingInfo().catch(() => this.showToastMessage('사용자 결제정보 업데이트 실패'))
          }
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'getPricingInfo',
        'showToastMessage'
      ]),
      hasHideNoticeInfo () {
        /**
         *
         * 로컬스토리지에 공지사항 '일주일간 보지 않기' 정보가 있을 경우 아래 두가지 조건을 확인합니다.
         * 1. 저장된 ID가 현재 활성화된 공지사항 ID와 동일한지 확인합니다.
         * 2. 숨기기 기한이 현재 날짜 기준으로 유효한지 확인합니다.
         * 두가지 조건을 만족할 경우 숨김 플래그를 True로 반환합니다.
         */

        const hideNoticeInfo = localStorage.getItem('hide_notice')

        if (hideNoticeInfo) {
          const info = JSON.parse(hideNoticeInfo)
          const isSameNotice = this.notice.id === info.id
          const isBeforeExpiration = moment(info.expiration_date).isAfter(moment())

          return isSameNotice && isBeforeExpiration
        }

        return false
      },
      getNotice () {
        axios.get('/biz/notice/?popup=Y&format=json')
          .then((response) => {
            const results = response.data.results
            if (results.length > 0) {
              this.notice = results[0]
              this.isActiveNotice = !this.hasHideNoticeInfo()
            }
          })
          .catch(() => {
            this.showToastMessage('공지사항 불러오기 실패')
          })
      },
      showLoginModal () {
        this.$refs.loginModal.show()
      },
      showLogoutModal () {
        this.$refs.logoutModal.show()
      },
      showChargeModal () {
        this.$refs.chargeModal.show()
      }
    },
    created () {
      this.getNotice()

      // 로그인 알림창 이벤트 등록
      eventHub.$on('showLoginModal', () => {
        this.showLoginModal()
      })

      // 이용권 구매 알림창 이벤트 등록
      eventHub.$on('showChargeModal', () => {
        this.showChargeModal()
      })
    }
  }
</script>

<style lang="scss">
  #wrapper {
    height: 100%;
  }

  .main {
    height: 100%;
  }

  .container {
    padding: 0;
  }

  .row {
    margin: 0;
    padding: 0;
  }

  .content {
    padding: 64px 0 0;

    .has-notice & {
      padding: 128px 0 0;
    }
  }

  .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12,
  .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6,
  .col-lg-7, .col-lg-8, .col-lg-9 {
    padding: 0 8px;
  }

  .col-md-1, .col-md-10, .col-md-11, .col-md-12,
  .col-md-2, .col-md-3, .col-md-4, .col-md-5,
  .col-md-6, .col-md-7, .col-md-8, .col-md-9 {
    padding: 0 8px;
  }

  .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
  .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5,
  .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9 {
    padding: 0 8px;
  }

  .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12,
  .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5,
  .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
    padding: 0 8px;
  }

  .table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 1px solid #ddd;
    color: $second-color;
  }

  .table>tbody>tr>td,
  .table>tbody>tr>th,
  .table>tfoot>tr>td,
  .table>tfoot>tr>th,
  .table>thead>tr>td,
  .table>thead>tr>th {
    padding: 15px 24px 15px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
  }

  @media(max-width: $screen-xs-max) {
    .mobile-gutter {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layouts/Main.vue